// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__199EF","buttons":"SendReceipts_buttons__-4r2U","email":"SendReceipts_email__1pvL9","bookApptTitle":"SendReceipts_bookApptTitle__1ILki"};